import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideCheck, LucideCircleAlert, LucideInfo, LucideTriangleAlert, LucideX } from '@lucide/angular';
import { ToastService, ToastMessage } from './toast.service';

@Component({
  selector: 'lib-toast',
  standalone: true,
  imports: [CommonModule, LucideCheck, LucideInfo, LucideTriangleAlert, LucideCircleAlert, LucideX],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  @Input() toast!: ToastMessage;
  private readonly toastService = inject(ToastService);

  close(): void {
    this.toastService.remove(this.toast.id);
  }
}
